module.exports = __webpack_public_path__ + "static/media/SALLE_LECTURE_COMMUNE_2.0452d159.jpg";